import { Action } from "@ngrx/store";

export interface ReduxAction<T> extends Action {
    type: string;
    payload?: T;
}

export const RESET_PRIVATE_REDUX_STATE = "RESET_PRIVATE_REDUX_STATE";

export const REQUEST_DATA_ACTION_PREFIX = "REQUEST_DATA_";
export const RECEIVE_DATA_ACTION_PREFIX = "RECEIVE_DATA_";
